import "./style.css";
import { useIntl } from "react-intl";
import { IconHamburger, LocaleSelector, logo } from "./shared";
import banner from "../assets/images/s3.png";

const desktopNavItems = [
  { href: "/all-driver", label: "DRIVER", messageId: "header.nav.driver", cls: "gTNDXh" },
  { href: "/all-ride", label: "RIDER", messageId: "header.nav.rider", cls: "gTNDXg" },
  { href: "/all-enterprise", label: "/business", messageId: "header.nav.business", cls: "gTNDXe" },
];

export default function Header() {
  const intl = useIntl();
  const currentPath = typeof window !== "undefined" ? window.location.pathname : "";
  const isActiveMenuItem = (href) => currentPath === href || currentPath.startsWith(`${href}/`);

  return (
    <>
    <header style={{ zoom: "0.87" }}>
      <div className="sc-laNGHT kVtRyo" />
      <div className="sc-pKqro cWTHFF">
        <div className="sc-cHMHOW gTpcvJ">
          <div data-testid="core-ui-layout-grid" className="sc-satoz jkAZmP">
            <div data-testid="core-ui-layout-container" className="sc-isRoRg keKQgy">
              <div className="sc-gvPdwL vaMkw">
                <a className="bbc-logo" aria-label={intl.formatMessage({ id: "header.logo.ariaLabel" })} href="/">
                  <img src={logo} alt={intl.formatMessage({ id: "header.logo.alt" })} className="bbc-logo-image" />
                  {/* <span>METUA'A</span> */}
                </a>
              </div>
            </div>

            <div data-testid="core-ui-layout-container" className="sc-isRoRg jLnuvr">
              <div className="sc-djVXDX ivHlJC">
                {/* <div className="sc-btwKTd gpRPEI">
                  <span data-testid="core-ui-button-wrapper" className="sc-eBMEME fVEXKH">
                    <a
                      data-testid="core-ui-button"
                      data-tracking-category="NavbarWidget"
                      data-tracking-action="click"
                      data-tracking-label="Get a ride button"
                      data-tracking-value="Demander une course"
                      aria-disabled="false"
                      href="https://lyft.sng.link/Adnq0/nd3x?_dl=lyft%3A%2F%2F&_smtype=3"
                      style={headerRideButtonStyle}
                      className="sc-dCFHLb sc-fhzFiK kVQIxK jPFbmJ header-cta-link header-nav-link"
                    >
                      <span className="sc-gmPhUn kESbtj">
                        <span data-testid="multi-line-text-wrap" className="sc-aXZVg kGRXWn">
                          <span data-testid="icon-button-text" className="sc-bmzYkS bmTkUk">
                            Demander une course
                          </span>
                        </span>
                      </span>
                    </a>
                  </span>
                  <div data-testid="core-ui-spacer" className="sc-gsFSXq TTsCq" />
                </div> */}

                <nav data-testid="DesktopNavigation" className="sc-DWsrX bcklQT">
                  <ul className="sc-iLWXdy ggbPbB">
                    {desktopNavItems.map((item) => (
                      <li key={item.href} className={`sc-eONNys ${item.cls}`}>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                        <a
                          href={item.href}
                          data-tracking-category="menu"
                          data-tracking-label={item.label}
                          className={`sc-gFnajm hpccuJ header-nav-link${isActiveMenuItem(item.href) ? " is-active" : ""}`}
                        >
                          <span data-testid="core-ui-text" className="sc-bmzYkS bmTkUk">
                            {intl.formatMessage({ id: item.messageId })}
                          </span>
                        </a>
                        <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      </li>
                    ))}

                    <li className="sc-eONNys bfOsFp">
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      <a
                        href="/signin-all"
                        data-tracking-category="menu"
                        data-tracking-label="Log In"
                        className={`sc-gFnajm hpccuJ header-nav-link${isActiveMenuItem("/signin-all") ? " is-active" : ""}`}
                      >
                        <span data-testid="core-ui-text" className="sc-bmzYkS ihhpyF">
                          {intl.formatMessage({ id: "header.nav.login" })}
                        </span>
                      </a>
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                    </li>

                    {/* <li className="sc-eONNys bfOsFp">
                      <div className="sc-feoqov ikFOug">
                        <a
                          href="signup-passenger"
                          data-tracking-category="riderWebOnboarding"
                          data-tracking-action="onboarding"
                          data-tracking-label="headerRiderSignUp"
                          data-tracking-value="desktop"
                          className="sc-gFnajm sc-gVJvzJ hpccuJ hkgqIB"
                        >
                          <span data-testid="core-ui-text" className="sc-bmzYkS ihhpyF">
                            Inscription
                          </span>
                        </a>
                      </div>
                    </li> */}

                    <li className="sc-eONNys bfOsFp">
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq erCIOG" />
                      <LocaleSelector />
                      <div data-testid="core-ui-spacer" className="sc-gsFSXq eVrKIz" />
                    </li>
                  </ul>
                </nav>

                <div className="sc-kuVLHQ jdOson">
                  <button
                    type="button"
                    aria-label={intl.formatMessage({ id: "header.mobileMenu.open" })}
                    aria-hidden="false"
                    data-tracking-category="menu"
                    data-tracking-value="Hamburger Button"
                    className="sc-epRvzc fTJiqd"
                  >
                    <span data-testid="core-ui-icon" className="sc-jEACwC cfWAWk">
                      <IconHamburger />
                    </span>
                  </button>
                </div>
              </div>

             
                
            </div>
          </div>
        </div>
      </div>
    </header>
    <img src={banner} alt={intl.formatMessage({ id: "header.logo.alt" })} className="w-full h-full" style={{"width": "100%","height":"60px","marginTop":"-5px"}}/>

    </>
    
  );
}

